// client/src/features/catalogue/routes.js
export default [
  {
    path: "/catalogue/",
    name: "catalogue",
    redirect: () => ({ name: "assemblies-library" }),
    meta: {
      layout: "app",
      group: "Catalogue",
      title: "Catalogue",
      breadcrumbs: [{ name: "Catalogue", route: "catalogue" }],
    },
  },
];